import styled from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import {
  azure1,
  azure2,
  cyan1,
  cyan2,
  green1,
  green2,
  grey3,
  grey5,
  magenta1,
  magenta2,
  orange1,
  orange2,
} from 'approot/shared/styles/colours.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import {
  spacing12,
  spacing16,
  spacing24,
  spacing4,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import { font16, font30 } from 'approot/shared/styles/typography.style';
import { borderRadius16 } from 'approot/shared/styles/borders.style';

function getDarkerColour(lexical: string) {
  switch (lexical) {
    case 'noun':
      return magenta2;
    case 'verb':
      return green2;
    case 'adjective':
      return cyan2;
    case 'adverbs':
      return azure2;
    case 'pronoun':
      return orange2;
    default:
      return grey5;
  }
}

function getLighterColour(lexical: string) {
  switch (lexical) {
    case 'noun':
      return magenta1;
    case 'verb':
      return green1;
    case 'adjective':
      return cyan1;
    case 'adverbs':
      return azure1;
    case 'pronoun':
      return orange1;
    default:
      return grey3;
  }
}

type VocabularyLexicalProps = {
  $lexical: string;
};
export const VocabularyLexical = styled.p<VocabularyLexicalProps>`
  ${flexCentreAlignCss}
  ${font16}

  ${mediaUp.md`
    ${font30}
  `}

  background-color: ${({ $lexical }) => getDarkerColour($lexical)};
  border-radius: ${rem(40)};
  display: inline-flex;
  margin-bottom: ${rem(spacing16)};
  padding: ${rem(spacing4)} ${rem(spacing12)};

  ${mediaUp.md`
    padding: ${rem(spacing8)} ${rem(spacing24)};
  `}
`;

export const VocabularyLexicalContainer = styled.div<VocabularyLexicalProps>`
  background-color: ${({ $lexical }) => getLighterColour($lexical)};
  border-radius: ${rem(borderRadius16)};
  margin-bottom: ${rem(spacing24)};
  padding: ${rem(spacing16)};

  ${mediaUp.md`
    padding: ${rem(spacing24)};
  `}
`;

export const VocabularyLexicalText = styled.p`
  ${font16}

  ${mediaUp.md`
    ${font30}
  `}
  margin-bottom: 0;
`;
